<script lang="ts">
	import type { Device } from 'src/types/Device';
	import LightAdvancedView from 'src/components/Sidepanel/DeviceViews/Light/LightAdvancedView.svelte';

	export let device: Device;
</script>

<LightAdvancedView {device} />
